import { useMemo } from 'react';
import { useGET } from '../shared/hooks';
import QueryString from '../../lib/QueryString';

const toUrl = (seasonId, teamId, query) =>
  `/stats/season/${seasonId}/team/${teamId}/ratings${query}`;

export function useOnOffMetrics(
  leagueId,
  seasonId,
  teamId,
  filters,
  sortKey,
  gameIds,
  division,
  conference,
) {
  const query = filtersToQueryString(
    leagueId,
    filters,
    gameIds,
    division,
    conference,
  );
  const url = toUrl(seasonId, teamId, query);
  const data = useGET(url);

  const teamList = useMemo(() => responseToTeamList(data), [data]);

  if (sortKey) {
    const [court, stat, descending] = sortKey;
    if (descending) {
      teamList.sort((a, b) => (a[court][stat] < b[court][stat] ? 1 : -1));
    } else {
      teamList.sort((a, b) => (a[court][stat] > b[court][stat] ? 1 : -1));
    }
  }
  return teamList;
}

function responseToTeamList(response) {
  return (
    response &&
    response.ratings.map(metric => ({
      id: metric.player.id,
      name: metric.player.name,
      normalized: metric.player.normalized,
      jersey: metric.player.jersey,
      on: metric.on,
      off: metric.off,
      net: metric.net,
      pace: metric.pace,
    }))
  );
}

function filtersToQueryString(
  leagueId,
  filters,
  gameIds,
  division,
  conference,
) {
  const query = new QueryString();
  query.addValue('league_id', leagueId);
  if (gameIds) query.addValue('games', gameIds);
  if (division) query.addValue('division', division);
  if (conference) query.addValue('conference', conference);
  return query.toString();
}
